export interface IProduct {
    idClient: number;
    description: string;
    id: number;
    weightLinkCPFEmail: number;
    weightLinkCPFTelephone: number;
    weightLinkCPFEaddress: number;
    weightLinkEmailTelephone: number;
    weightLinkEmailAddress: number;
    weightLinkTelephoneAddress: number;
    tagBiometria: boolean;
    verifyAllPartners: boolean;
    riskLevelParameter: number;
  }

  export enum NivelRisco {
    AltissimoRisco = 0,
    AltoRisco = 1,
    MedioRisco = 2,
    BaixoRisco = 3,
    BaixissimoRisco = 4,
  }